import React, {useState} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";

export const ServiceBookResumeWaitingListItem = ({item, onRemove, className}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleRemove = () => {
        if (isDeleting) return;
        setIsDeleting(true);

        onRemove(item)
            .catch(() => {
                // error handled upstream
            })
            .finally(() => setIsDeleting(false));
    };

    const dateFormats = ["YYYY-MM-DD", "DD-MM-YYYY", moment.ISO_8601];
    const parsedDate = item.date ? moment(item.date, dateFormats, true) : null;
    const formattedDate = parsedDate && parsedDate.isValid()
        ? parsedDate.format("DD MMMM YYYY")
        : (item.date || "");
    const timeRange = [item.start_time, item.end_time].filter(Boolean).join(" - ");
    const professional = item.professional_name || item.nome_dipendente || "";
    const serviceName = item.service_name || item.nome_servizio || "";

    const wrapperClassName = ["d-flex align-items-center justify-content-between", className]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={wrapperClassName}>
            <div>
                {
                    !!serviceName &&
                    <div className={"text-on-bg-main font-weight-bold"}>
                        {serviceName}
                    </div>
                }
                <div className={"text-muted small"}>
                    {[formattedDate, timeRange].filter(Boolean).join(" • ")}
                </div>
                {
                    !!professional &&
                    <div className={"text-muted small"}>
                        Operatore: {professional}
                    </div>
                }
            </div>
            <button
                className={"btn btn-sm btn-link text-danger"}
                onClick={handleRemove}
                disabled={isDeleting}
            >
                <FaSolidIcon name={"trash"}/>
            </button>
        </div>
    );
};

ServiceBookResumeWaitingListItem.propTypes = {
    item: PropTypes.shape({
        date: PropTypes.string,
        start_time: PropTypes.string,
        end_time: PropTypes.string,
        service_name: PropTypes.string,
        nome_servizio: PropTypes.string,
        professional_name: PropTypes.string,
        nome_dipendente: PropTypes.string
    }).isRequired,
    onRemove: PropTypes.func.isRequired,
    className: PropTypes.string
};
